import React from 'react'
import { Stack, Typography } from '@mui/material'
import useResponsive from 'hooks/useResponsive'

type Props = {
  textSuggestion: string[]
  showInstruction: boolean
}

export function TreatEmptySuggestion ({ textSuggestion, showInstruction = false }: Props) {
  const mdUp = useResponsive('up', 'md')
  if (showInstruction) {
    return (
      <Stack
        justifyContent={'center'}
        sx={{ height: (!mdUp ? '52vh' : '') }}
        border={'1px dashed grey'}
        alignItems={'center'}
        p={4}
        flex={1}
        borderRadius={2}
        mt={1.5}
        direction={{ xs: 'column', sm: 'row' }}
      >
        <Stack
          flex={0.5}
          p={2}
          border={'2px dashed #d6500d'}
          textAlign={'justify'}
          justifyContent={'center'}
        >
          { textSuggestion.map(function (val, index) { return <Stack p={1} key={index}><Typography variant='h5'>{ val }</Typography></Stack> }) }
        </Stack>
        { mdUp && <Stack
          flex={0.2}
          alignItems="center"
          p={4}
        >
          <img width={'70%'} src='https://d1a2cw5nz65orm.cloudfront.net/delta-suggestions.png' />
        </Stack>
        }
      </Stack>
    )
  }
  return null
}
